<template>
    <td-dialog heigh="100px" :title="$t(title)" :before-close="userDialogClose" :visible.sync="dialogUserVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formUserInfo" ref="formUserInfo" :label-position="labelPosition" :rules="rules">
            <el-form-item :label="$t('common.USERNAME')" class="itemStyle" :label-width="formLabelWidth" prop="userName">
                <td-input :disabled="autoDisabled" v-model="formUserInfo.userName"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.EMAIL')" class="itemStyle" :label-width="formLabelWidth" prop="email">
                <td-input :disabled="autoDisabled" v-model="formUserInfo.email"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.PHONE_NO')" class="itemStyle" :label-width="formLabelWidth" prop="phoneNo">
                <td-input :disabled="autoDisabled" v-model="formUserInfo.phoneNo"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.LOCK_STATE')" class="itemStyle" :label-width="formLabelWidth" prop="lockState">
                <td-select :disabled="autoDisabled" v-model="formUserInfo.lockState" :options="options"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.UPPER')" class="itemStyle" :label-width="formLabelWidth" prop="upper">
                <td-input v-model="formUserInfo.upper"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" @click="submitForm('formUserInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="userDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogUserVisible', 'editItem', 'isAddData', 'selectOptions'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
            this.autoDisabled = true;
        }
        // this.options = this.selectOptions
    },
    // 定义变量
    data() {
        return {
            formLabelWidth: '30%',
            // 用户信息
            formUserInfo: {
                userName: '',
                email: '',
                phoneNo: '',
                lockState: '',
                upper: ''
            },
            // 对表单进行数据验证
            rules: {
                userName: [
                    { required: true, message: this.$t('error.ERROR_INPUT_MENU_NAME'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.error_caption_max_length'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                email: [{ required: true, message: this.$t('error.ERROR_INPUT_SUPERIOR_MENU'), trigger: 'blur' }],
                phoneNo: [{ required: true, message: this.$t('error.ERROR_INPUT_MENU_SORT'), trigger: 'blur' }]
            },
            // 锁定状态下拉列表
            options: [
                {
                    value: '1',
                    label: this.$t('common.LOCKED')
                },
                {
                    value: '0',
                    label: this.$t('common.NOT_LOCKED')
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formUserInfo.userName = this.editItem.userName;
            this.formUserInfo.email = this.editItem.email;
            this.formUserInfo.phoneNo = this.editItem.phoneNo;
            this.formUserInfo.lockState = this.editItem.lockState;
            this.formUserInfo.upper = this.editItem.upper;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let content = {
                        userName: this.formUserInfo.userName,
                        email: this.formUserInfo.email,
                        phoneNo: this.formUserInfo.phoneNo,
                        lockState: this.formUserInfo.lockState,
                        upper: this.formUserInfo.upper
                    };
                    if (this.isAddData) {
                        this.$api.insertMenuInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message.error(response.data.statusMessage);
                                this.$log.error('dialogMenuinfo/insertMemuInfo', response.data.statusMessage);
                                return;
                            }
                            this.$message.success(this.$t('common.ADD_SUCCESS'));
                            this.userDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    } else {
                        content.uid = this.editItem.uid;
                        this.$api.editUserInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message.error(response.data.statusMessage);
                                this.$log.error('dialogMqinfo/updateMqInfo', response.data.statusMessage);
                                return;
                            }
                            this.$message.success(this.$t('common.MODIFY_SUCCESS'));
                            this.userDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        userDialogClose() {
            this.$emit('userDialogClose');
            this.$refs['formUserInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
</style>
